import {
  type EmailSignatureBasicSelectOption,
  EmailSignatureContactDetailsFieldTypes,
  type EmailSignatureIconName,
  EmailSignatureSideEditorItems,
  EmailSignatureSizes,
  EmailSignatureSocialLinkTypes,
  type Icons,
} from './types';

export enum EmailSignatureContactDetailsFieldWidth {
  HALF_WIDTH = 'half-width',
  FULL_WIDTH = 'full-width',
}

export enum EmailSignatureFieldPrefixes {
  SOCIAL = 'sc_',
  CONTACT = 'ct_',
  ENVIRONMENTAL_FOOTER = 'en_',
  BANNER = 'bn_',
  LEGAL_DISCLAIMER = 'le_',
  SAVE_CONTACT = 'sa_',
  IMAGE = 'im_',
}

export enum EmailSignatureFieldTypes {
  SOCIAL = 'social',
  CONTACT = 'contact',
  ENVIRONMENTAL_FOOTER = 'environmental_footer',
  BANNER = 'banner',
  SAVE_CONTACT = 'save_contact',
  IMAGE = 'image',
}

export const MenuItemsIndexDictionary = {
  [EmailSignatureSideEditorItems.DETAILS]: 0,
  [EmailSignatureSideEditorItems.IMAGES]: 1,
  [EmailSignatureSideEditorItems.SOCIAL]: 2,
  [EmailSignatureSideEditorItems.DESIGN]: 3,
  [EmailSignatureSideEditorItems.BANNERS]: 4,
  [EmailSignatureSideEditorItems.SETTINGS]: 5,
};

export const PHONE_NUMBER_ICONS: Icons['Phone'][] = [
  'phone-alt',
  'phone',
  'phone-rotary',
  'phone-office',
  'mobile',
];
export const EMAIL_ICONS: Icons['Email'][] = [
  'envelope',
  'envelope-open',
  'envelope-open-text',
  'inbox',
  'inbox-in',
  'mailbox',
];
export const WEBSITE_ICONS: Icons['Website'][] = [
  'browser',
  'calendar',
  'globe',
  'laptop',
  'laptop-code',
  'link',
  'external-link',
];
export const ADDRESS_ICONS: Icons['Address'][] = [
  'map-marker-alt',
  'map-pin',
  'map',
  'map-marked-alt',
  'location-arrow',
  'location',
];
export const SKYPE_ICONS: Icons['Skype'][] = ['skype'];
export const WHATSAPP_ICONS: Icons['WhatsApp'][] = ['whatsapp'];
export const SIGNAL_ICONS: Icons['Signal'][] = ['signal'];
export const FAX_ICONS: Icons['Fax'][] = [
  'fax',
  'phone-office',
  'paperclip',
  'paper-plane',
  'print',
  'inbox',
];

export const CONTACT_FIELD_ICON_OPTIONS = {
  [EmailSignatureContactDetailsFieldTypes.PHONE]: PHONE_NUMBER_ICONS,
  [EmailSignatureContactDetailsFieldTypes.EMAIL]: EMAIL_ICONS,
  [EmailSignatureContactDetailsFieldTypes.WEBSITE]: WEBSITE_ICONS,
  [EmailSignatureContactDetailsFieldTypes.ADDRESS]: ADDRESS_ICONS,
  [EmailSignatureContactDetailsFieldTypes.SKYPE]: SKYPE_ICONS,
  [EmailSignatureContactDetailsFieldTypes.WHATSAPP]: WHATSAPP_ICONS,
  [EmailSignatureContactDetailsFieldTypes.SIGNAL]: SIGNAL_ICONS,
  [EmailSignatureContactDetailsFieldTypes.FAX]: FAX_ICONS,
};

export const BRAND_COLORS: Record<EmailSignatureSocialLinkTypes, string> = {
  [EmailSignatureSocialLinkTypes.YOUTUBE]: '#ff0000',
  [EmailSignatureSocialLinkTypes.LINKEDIN]: '#0077b5',
  [EmailSignatureSocialLinkTypes.TWITTER]: '#000000',
  [EmailSignatureSocialLinkTypes.FACEBOOK]: '#1877f2',
  [EmailSignatureSocialLinkTypes.INSTAGRAM]: '#e1306c',
  [EmailSignatureSocialLinkTypes.SNAPCHAT]: '#F5F200', // Actual snapchat color is too bright
  [EmailSignatureSocialLinkTypes.TWITCH]: '#9146ff',
  [EmailSignatureSocialLinkTypes.GITHUB]: '#333',
  [EmailSignatureSocialLinkTypes.CALENDLY]: '#106BFF',
  [EmailSignatureSocialLinkTypes.PAYPAL]: '#003087',
  [EmailSignatureSocialLinkTypes.VENMO]: '#3d95ce',
  [EmailSignatureSocialLinkTypes.CASHAPP]: '#00C244',
  //[EmailSignatureSocialLinkTypes.PATREON]: "#f96854",
  [EmailSignatureSocialLinkTypes.DISCORD]: '#7289da',
  [EmailSignatureSocialLinkTypes.YELP]: '#af0606',
  [EmailSignatureSocialLinkTypes.TIKTOK]: '#010101',
};

export const EM_SIG_IMAGE_MAXIMUM_WIDTH = 130;
export const EM_SIGN_IMAGES_MARGIN_RIGHT = 25;

export const GOLDEN_RATIO = 1.3195;
export const EM_SIG_FONT_SIZE_BASE = 13;
export const EM_SIG_FONT_SIZE_LABEL = EM_SIG_FONT_SIZE_BASE - 3;
export const EM_SIG_FONT_SIZE_LABEL_WITHOUT_ICON = EM_SIG_FONT_SIZE_BASE - 2;
export const EM_SIG_FONT_SIZE_PRIMARY = Math.ceil(EM_SIG_FONT_SIZE_BASE * GOLDEN_RATIO);
export const EM_SIG_FONT_SIZE_SECONDARY = 11;
export const EM_SIG_FONT_SIZE_EXTENSION = EM_SIG_FONT_SIZE_BASE - 2;

// font colours
export const EM_SIG_FONT_COLOR = '#7a7a7a';
export const EM_SIG_SECONDARY_FONT_COLOR = '#9e9e9e';

export const EM_SIG_IMAGES_SIZES_DICT = {
  [EmailSignatureSizes.SMALL]: 90,
  [EmailSignatureSizes.MEDIUM]: 110,
  [EmailSignatureSizes.LARGE]: EM_SIG_IMAGE_MAXIMUM_WIDTH,
};
export const EM_SIG_IMAGE_SQUIRCLE_RADIUS = 10;

export const EM_SIG_CONTACT_ICON_SIZE = 12;
export const EM_SIG_EM_SIG_CONTACT_ICON_SIZE_ACTUAL_SIZE = 24;
export const EM_SIG_CONTACT_ICONS_PADDING = 7.5;
export const EM_SIG_CONTACT_CELL_PADDING = 16;
export const EM_SIG_MAXIMUM_HALF_WIDTH_CONTACT_FIELD_LENGTH = 145;

export const EM_SIG_MAXIMUM_FULL_WIDTH_CONTACT_FIELD_LENGTH =
  EM_SIG_MAXIMUM_HALF_WIDTH_CONTACT_FIELD_LENGTH * 2 +
  EM_SIG_CONTACT_CELL_PADDING +
  EM_SIG_CONTACT_ICONS_PADDING +
  EM_SIG_EM_SIG_CONTACT_ICON_SIZE_ACTUAL_SIZE;

export const EM_SIG_MAXIMUM_HALF_WIDTH_CONTACT_FIELD_LENGTH_WITHOUT_ICON =
  EM_SIG_MAXIMUM_HALF_WIDTH_CONTACT_FIELD_LENGTH +
  EM_SIG_CONTACT_ICONS_PADDING +
  EM_SIG_EM_SIG_CONTACT_ICON_SIZE_ACTUAL_SIZE;
export const EM_SIG_MAXIMUM_FULL_WIDTH_CONTACT_FIELD_LENGTH_WITHOUT_ICON =
  EM_SIG_MAXIMUM_HALF_WIDTH_CONTACT_FIELD_LENGTH_WITHOUT_ICON * 2 + EM_SIG_CONTACT_CELL_PADDING;

export const EM_SIG_PERSONAL_DETAILS_MAX_WIDTH =
  EM_SIG_MAXIMUM_FULL_WIDTH_CONTACT_FIELD_LENGTH_WITHOUT_ICON;

export const SAVE_CONTACT_BUTTON_HEIGHT = 30;
export const SAVE_CONTACT_BUTTON_WIDTH = 110;
export const MAIN_SECTION_WITHOUT_IMAGE_WIDTH =
  EM_SIG_MAXIMUM_FULL_WIDTH_CONTACT_FIELD_LENGTH_WITHOUT_ICON + EM_SIG_CONTACT_CELL_PADDING;

export const EM_SIG_SOCIAL_ICON_SQUIRCLE_RADIUS = 10;
export const EM_SIG_SOCIAL_ICON_SIZES_DICT = {
  [EmailSignatureSizes.SMALL]: 24,
  [EmailSignatureSizes.MEDIUM]: 32,
  [EmailSignatureSizes.LARGE]: 40,
};
export const EM_SIG_SOCIAL_ICON_PADDING = 8;

export const EMAIL_SIGNATURE_ENVIRONMENTAL_FOOTER_ICON_SIZE = 36;

export const ENVIRONMENTAL_FOOTER_OPTIONS: EmailSignatureBasicSelectOption[] = [
  { label: 'Think before you print', value: 'Think before you print' },
  {
    label: 'Please consider the environment before printing',
    value: 'Please consider the environment before printing',
  },
  { label: "Save paper. Don't print", value: "Save paper. Don't print" },
  {
    label: 'Thank you for not printing this email',
    value: 'Thank you for not printing this email',
  },
  {
    label: 'Do you really need to print this email',
    value: 'Do you really need to print this email',
  },
  { label: 'Your own custom footer', value: '' },
];

export const ENVIRONMENTAL_FOOTER_ICON_OPTIONS: EmailSignatureIconName[] = [
  'leaf',
  'leaf-heart',
  'leaf-maple',
  'leaf-oak',
  'canadian-maple-leaf',
  'tree',
  'trees',
  'tree-alt',
  'tree-large',
  'tree-decorated',
];

export const ENVIRONMENTAL_FOOTER_COLOR = '#3db512';

export const LEGAL_DISCLAIMER_OPTIONS: EmailSignatureBasicSelectOption[] = [
  {
    label: 'Confidentiality',
    value:
      'Important: The content of this email is confidential and intended for the recipient specified in message only. It is strictly forbidden to share any part of this message with any third party, without a written consent of the sender. If you received this message by mistake, please reply to this message and follow with its deletion, so that we can ensure such a mistake does not occur in the future.',
  },
  {
    label: 'Personal opinions',
    value:
      'Important: The views and opinions included in this email belong to their author and do not necessarily mirror the views and opinions of the company. Our employees are obliged not to make any defamatory clauses, infringe, or authorize infringement of any legal right. Therefore, the company will not take any liability for such statements included in emails. In case of any damages or other liabilities arising, employees are fully responsible for the content of their emails.',
  },
  {
    label: 'No viruses',
    value:
      'Important: Computer viruses can be transmitted via email. The recipient should check this email and any attachments for the presence of viruses. The organization accepts no liability for any damage caused by any virus transmitted by this email. Email transmission cannot be guaranteed to be secure or error-free, as information could be intercepted, corrupted, lost, destroyed, arrive late or incomplete, or contain viruses. The sender, therefore, does not accept liability for any errors or omissions in the contents of this message which arise as a result of email transmission.',
  },
  {
    label: 'Correct recipient',
    value:
      'Important: Our company accepts no liability for the content of this email, or for the consequences of any actions taken on the basis of the information provided, unless that information is subsequently confirmed in writing. If you are not the intended recipient you are notified that disclosing, copying, distributing or taking any action in reliance on the contents of this information is strictly prohibited.',
  },
  {
    label: 'Non-bindings',
    value:
      'Important: No employee or agent is authorized to conclude any binding agreement on behalf of the company with another party by email without specific confirmation',
  },
  { label: 'Your own custom disclaimer', value: 'Important: ' },
];

export const EMAIL_SIGNATURE_LEGAL_FONT_SIZES_DICT = {
  [EmailSignatureSizes.SMALL]: 10,
  [EmailSignatureSizes.MEDIUM]: 12,
  [EmailSignatureSizes.LARGE]: 15,
};

export const EMAIL_SIGNATURE_WIDTH =
  MAIN_SECTION_WITHOUT_IMAGE_WIDTH + EM_SIGN_IMAGES_MARGIN_RIGHT + EM_SIG_IMAGE_MAXIMUM_WIDTH;
export const EMAIL_SIGNATURE_WIDTH_WITHOUT_IMAGE = MAIN_SECTION_WITHOUT_IMAGE_WIDTH;
export const EMAIL_SIGNATURE_WIDTH_WITH_SMALL_IMAGE =
  MAIN_SECTION_WITHOUT_IMAGE_WIDTH +
  EM_SIGN_IMAGES_MARGIN_RIGHT +
  EM_SIG_IMAGES_SIZES_DICT['small'];
export const EMAIL_SIGNATURE_WIDTH_WITH_MEDIUM_IMAGE =
  MAIN_SECTION_WITHOUT_IMAGE_WIDTH +
  EM_SIGN_IMAGES_MARGIN_RIGHT +
  EM_SIG_IMAGES_SIZES_DICT['medium'];

export const EMAIL_SIGNATURE_BANNER_SIZES_DICT = {
  [EmailSignatureSizes.SMALL]: 200,
  [EmailSignatureSizes.MEDIUM]: 400,
  [EmailSignatureSizes.LARGE]: EMAIL_SIGNATURE_WIDTH,
};

// for now we do not allow the users to change the icons of the contact detail fields
export const ENABLE_CHANGING_ICONS = false;

// for now we do not allow the users to give images in the main section external links
// because it is applicable for image-based signature
export const ENABLE_EXTERNAL_LINK_FOR_IMAGE = false;

// for now we do not allow the users to change the width of the banner because we want to keep the
// the retroactive update for image-based signature
export const ENABLE_BANNER_WIDTH_OPTIONS = false;

// for now disable design options for contact details
export const ENABLE_CONTACT_DETAILS_OPTIONS = false;

// for now disable custom colour option for links
export const ENABLE_SOCIAL_LINKS_CUSTOM_COLOR = false;

// for now disable custom colour option for save contact button
export const ENABLE_SAVE_CONTACT_CUSTOM_COLOR = false;
